import { IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

const BENGALI_DIGITS = '০১২৩৪৫৬৭৮৯';
const localizeDigits = (value, isBn) => (isBn
    ? String(value).replace(/\d/g, (digit) => BENGALI_DIGITS[Number(digit)])
    : String(value));

/**
 * The "page 1 / 2" marker that rides on the preview canvas.
 *
 * A two-page form fitted to the card looks exactly like a one-page form — the
 * second page is below the fold with nothing on screen to hint at it. This
 * says how many there are, which one is showing, and (until you reach the last)
 * points down to say the canvas scrolls.
 */
export default function PagePreviewPages({ page, total }) {
    const { t, currentLanguage } = useTranslation();
    const isBn = currentLanguage === 'bn';

    if (!total || total < 2) return null;

    return (
        <div className="pointer-events-none absolute right-4 top-4 z-10 flex items-center gap-1.5 rounded-full bg-[#1C1815]/75 px-3 py-1.5 text-[11.5px] font-semibold text-white shadow-[0_2px_10px_rgba(0,0,0,0.35)] backdrop-blur-[2px]">
            <span className="tabular-nums">
                {t('toolPage.preview.pageOf', {
                    current: localizeDigits(page, isBn),
                    total: localizeDigits(total, isBn),
                })}
            </span>
            {page < total ? (
                <IconChevronDown size={13} stroke={2.2} className="animate-bounce text-white/80" />
            ) : null}
        </div>
    );
}
